import splitTwo from './2.svg?url';
import splitThree from './3.svg?url';
import splitTwoWarning from './2-warning.svg?url';
import splitThreeWarning from './3-warning.svg?url';

export const getImageSplit = (nbrOfOutputs: number, hasFlow = true) => {
  switch (nbrOfOutputs) {
    case 2:
      return hasFlow ? splitTwo : splitTwoWarning;
    case 3:
      return hasFlow ? splitThree : splitThreeWarning;
    default:
      return hasFlow ? splitTwo : splitTwoWarning;
  }
};
